<template>
  <div class="bbr-canonical-exercise--list">
    <v-simple-table>
      <thead>
        <tr>
          <th class="col-name">Canonical Exercise</th>
          <th class="col-count">Linked Exercises</th>
          <th class="col-actions text-right">Actions</th>
        </tr>
      </thead>

      <tbody
        v-infinite-scroll="loadMore"
        :infinite-scroll-disabled="disableListScroll"
        infinite-scroll-distance="50"
      >
        <tr
          v-for="canonicalExercise in list"
          :key="canonicalExercise.id"
          class="clickable new-tab-link-row"
        >
          <td class="col-name" v-list-link="setListLink(canonicalExercise.id)">
            {{ canonicalExercise.name }}
          </td>
          <td class="col-count" v-list-link="setListLink(canonicalExercise.id)">
            {{ canonicalExercise.exercises_count }}
          </td>
          <td class="col-actions text-right" @click.stop>
            <v-btn icon @click="$emit('edit', canonicalExercise)">
              <v-icon>{{ icons.edit }}</v-icon>
            </v-btn>
            <v-btn icon @click="$emit('delete', canonicalExercise)">
              <v-icon>{{ icons.delete }}</v-icon>
            </v-btn>
          </td>
        </tr>
      </tbody>

      <table-skeleton-loader v-if="isLoading" column="3" row />
    </v-simple-table>

    <no-list v-if="!hasList && !isLoading" details="No Canonical Exercises" />
  </div>
</template>

<script>
import TableSkeletonLoader from '@/components/elements/loaders/TableSkeleton'
import NoList from '@/components/elements/NoList'
import infiniteScroll from 'vue-infinite-scroll'

import { mapGetters } from 'vuex'
import { mdiPencil, mdiDelete } from '@mdi/js'

export default {
  name: 'CanonicalExerciseList',

  directives: {
    infiniteScroll,
  },

  components: {
    TableSkeletonLoader,
    NoList,
  },

  props: {
    isLoading: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      icons: {
        edit: mdiPencil,
        delete: mdiDelete,
      },
    }
  },

  computed: {
    ...mapGetters({
      list: 'canonicalExercises/list',
      hasList: 'canonicalExercises/hasList',
      meta: 'canonicalExercises/meta',
    }),

    lastPage() {
      return this.meta.current_page >= this.meta.last_page
    },

    disableListScroll() {
      return this.isLoading || this.lastPage
    },
  },

  methods: {
    loadMore() {
      if (!this.disableListScroll) {
        this.$emit('load', this.meta.current_page + 1)
      }
    },

    setListLink(id) {
      return {
        id,
        routeName: 'canonical-exercise',
        fullPath: `/canonical-exercises/${id}`,
      }
    },
  },
}
</script>

<style scoped>
.col-actions {
  width: 120px;
}
.clickable {
  cursor: pointer;
}
</style>
